import type { Hotel } from '@/config/objects/hotels';
import { useOutletContext } from 'react-router-dom';

interface HotelContext {
  hotel: Hotel | undefined;
  isLoading: boolean;
}

export function useHotelContext() {
  return useOutletContext<HotelContext>();
}
